module.exports = __webpack_public_path__ + "img/VALOR_RESPONSABILIDAD2.cd505e1a.png";